<template>
  <v-row>
    <v-col cols="4" lg="4" offset-lg="4" md="6" offset-md="4">
      <v-card class="elevation-12 mt-3 mx-1" :loading="loading">
        <v-toolbar color="primary" dark flat>
          {{ pageTitle }}
          <v-spacer/>
          <v-btn color="success" small @click="onRefreshButtonClicked">Обновить</v-btn>
        </v-toolbar>

        <template>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" lg="12">
                <v-text-field v-model="mailUid"
                              label="Идентификатор письма"
                              @keyup.enter="onMailUidKeyUpEnter"
                              ref="mailUid"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th style="width: 10px">№</th>
                  <th class="text-center">Идентификатор</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="mail in displayMails" :key="mail.id"
                    :class="{'black': mail.isPerformedNotTry, 'white--text': mail.isPerformed}">
                  <td>{{ mail.displayNumber }}</td>
                  <td class="text-center">
                    {{ mail.uid }}
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </template>

        <v-card-actions>
          <v-spacer/>
          <span>Писем: {{ mailsCount }}</span>
          <v-spacer/>
        </v-card-actions>

        <v-snackbar v-model="mailSuccessfullyAdded"
                    :timeout="2000"
                    :top="true"
                    color="success"
        >
          Письмо успешно зарегистрировано
        </v-snackbar>
        <v-snackbar v-model="invalidFormat"
                    :timeout="2000"
                    :top="true"
                    color="error"
        >
          Неверный номер письма
        </v-snackbar>
        <v-snackbar v-model="mailAlreadyHasBeenAdded"
                    :timeout="2000"
                    :top="true"
                    color="warning"
        >
          Письмо уже регистрировано
        </v-snackbar>
        <v-snackbar v-model="setMailPostPackageFailed"
                    :timeout="2000"
                    :top="true"
                    color="error"
        >
          Не удалось регистрировать письмо
        </v-snackbar>
        <v-snackbar v-model="maximumLimitReachedPerPackageSnackbar"
                    :timeout="2000"
                    :top="true"
                    color="error"
        >
          Больше добавить писем не получится. Есть ограничение на максимальное количество писем в пакете
          {{ maxMailsPerPackageLimit }}
        </v-snackbar>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import _ from "underscore";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import {required} from 'vuelidate/lib/validators'
import MailService from '@/services/mail.service'
import {AllowCreatePostPackage, AllowUnsetMailPostPackage} from "@/enums/permission";
import Moment from "moment";

export default {
  name: "SetAncientMailsView",
  data() {
    return {
      // datatable
      mails: [],
      loading: false,

      maxMailsPerPackageLimit: 50,

      mailUid: '',

      mailSuccessfullyAdded: false,
      invalidFormat: false,
      mailAlreadyHasBeenAdded: false,
      setMailPostPackageFailed: false,

      maximumLimitReachedPerPackageSnackbar: false
    }
  },
  validations: {
    mailUid: {
      required
    }
  },
  computed: {
    pageTitle() {
      return 'Регистрация писем с пост пакета'
    },
    isPostPackageLoaded() {
      return !!this.tempPostPackage
    },
    mailsCount() {
      return this.mails.length
    },
    mailsPagesSum() {
      let sum = 0
      _.each(this.mails, m => {
        sum += m.pagesCount
      })

      return sum
    },
    displayMails() {
      let number = this.mails.length;
      return _.map(this.mails, m => {
        m.displayNumber = number--

        return m
      })
    },
    isAllowPostPackageCreate() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePostPackage
      })
    },

    isAllowUnsetPostPackageMail() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowUnsetMailPostPackage
      })
    },
  },
  methods: {
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },

    onRefreshButtonClicked() {
      debugger
      this.mails = [];
      debugger
    },
    onMailUidKeyUpEnter() {
      this.$v.$touch()
      this.mailUid = this.mailUid.trim()

      if (this.mails.length >= this.maxMailsPerPackageLimit) {
        this.maximumLimitReachedPerPackageSnackbar = true
        return;
      }

      if (!this.$v.$invalid) {
        this.loading = true
        this.$store.dispatch(LAYOUT_LOADING_START)

        this.setMailPostPackageFailed = false
        MailService.setAncientMail({mailUid: this.mailUid})
            .then(response => {
              this.mails.push({
                id: response.data.Id,
                uid: response.data.Uid,
                createdOn: Moment(response.data.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss')
              })

              this.mailSuccessfullyAdded = true
            })
            .catch((error) => {
              if (error) {
                switch (error.response.status) {
                  case 400: this.invalidFormat = true; break;
                  case 409: this.mailAlreadyHasBeenAdded = true; break;
                  case 500: this.setMailPostPackageFailed = true; break;
                }
              }

            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)

              this.mailUid = ''
            })
      } else {
        this.mailUid = ''
      }
    }
  },
  created() {
    if (this.isAllowPostPackageCreate) {
      this.setPageTitle()
    } else {
      this.$router.go(-1)
    }
  },
  watch: {
    "$route": function () { }
  },
}
</script>

<style scoped>

</style>